import cn from 'classnames';
import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import type { Product } from '@/domain/Product';
import styles from './QuickViewHeadingGroup.module.scss';
import useWidgetOptions from '@/widgets/hooks/useWidgetOptions';
import type { Options } from '@/widgets/ProductList/config';

export type QuickViewHeadingGroupProps = {
  product: Product;
  trackingPosition?: number;
  trackingList?: string;
  class?: string;
  headingAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
};

const TEXT_CONTENT_OPTIONS = {
  HEADLINE: 'headline',
  DESCRIPTION: 'description'
};

function QuickViewHeadingGroup({
  product: { name, headline = '', description = '' },
  trackingPosition,
  trackingList,
  class: className,
  headingAs = 'h1',
  ...rest
}: QuickViewHeadingGroupProps) {
  const { visibleQuickViewText } = useWidgetOptions<Options>();
  const showDescription =
    visibleQuickViewText === TEXT_CONTENT_OPTIONS.DESCRIPTION;
  const contentText = showDescription ? description : headline;

  if (!name && !contentText) return null;

  const Heading = headingAs;

  return (
    <hgroup class={cn(styles.container, className)} {...rest}>
      {name && <Heading className={styles.name}>{name}</Heading>}
      {contentText && (
        <FormattedText
          as="p"
          className={cn({ [styles.headline]: !showDescription })}
        >
          {contentText}
        </FormattedText>
      )}
    </hgroup>
  );
}

export default QuickViewHeadingGroup;
